import styled from "styled-components/macro";
import { Modal } from "react-bootstrap";

export const CreatorsUserLogsWrapper = styled.div`
  .link-text-pointer {
    cursor: pointer;
    text-underline-offset: 1px;
    text-underline-position: from-font;
  }

  .table-wrapper-styles {
    tbody tr td {
      &.actions {
        opacity: 1;
        background: transparent;
      }
    }
  }
  .table-full-view {
    height: calc(100vh - 284px);
  }
`;

export const CreatorVerifyModalStyles = styled(Modal)`
  .modal-header {
    border-bottom: 1px solid var(--Neutral-8);
    height: 72px;

    .modal-title {
      color: var(--Neutral-100);
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.3px;
    }
  }
  .modal-body {
    padding: 24px;
    height: calc(100vh - 187px);
    display: flex;
    flex-direction: column;
    gap: 24px;

    .creators-innstagram-info {
      max-width: 168px;
      width: 100%;

      .logo-text {
        display: flex;
        align-items: center;
        gap: 4px;
        color: var(--Neutral-60);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.012px;

        svg {
          width: 12px;
          height: 12px;
        }
      }

      .main-text {
        overflow: hidden;
        color: var(--Neutral-100);
        text-overflow: ellipsis;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.16px;
        cursor: pointer;
      }
    }

    .private-profile-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;

      h4 {
        color: var(--Neutral-60);
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }

      .radio-wrapper {
        display: flex;
        flex-direction: column;
        padding: 4px 0;
        gap: 4px;
      }
    }
  }

  .modal-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 16px;
    height: 81px;
    gap: 8px;
    border-top: 1px solid var(--Neutral-8);

    button {
      width: 100%;
    }
  }
`;
